import { render, staticRenderFns } from "./RssBlogFeed.vue?vue&type=template&id=2d8b495e&"
import script from "./RssBlogFeed.vue?vue&type=script&lang=js&"
export * from "./RssBlogFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports